import { render, staticRenderFns } from "./userDataUpdate.vue?vue&type=template&id=01988871&"
import script from "./userDataUpdate.vue?vue&type=script&lang=js&"
export * from "./userDataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports